import PropTypes from 'prop-types'
import React from 'react'
import PhoneField from '../question_config_fields/PhoneField'
import * as validations from '../../../utils/validations'
import PhoneIcon from '@material-ui/icons/Phone'
import TextWithInfoField from '../../molecules/TextWithInfoField'

const Form = props => {
  return <PhoneField baseName={props.baseName} validate={validations.required()} />
}

const Template = props => {
  return (
    <TextWithInfoField
      payload={props.question.payload}
      name={props.name}
      infoContent="Se validará que la respuesta contenga solo números."
      disabled
    />
  )
}

const PhoneQuestion = {
  selectOption: { value: 'phone', label: 'Teléfono', icon: <PhoneIcon fontSize="small" /> },
  Form,
  Template,
  name: 'PhoneQuestion'
}

export default PhoneQuestion

Form.propTypes = {
  baseName: PropTypes.string
}

Template.propTypes = {
  name: PropTypes.string,
  question: PropTypes.object.isRequired
}
